/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A way to reach the resident that their consent covers (TXN-3476).
 * @export
 */
export const HomeownershipConsentChannel = {
    Email: 'email',
    Call: 'call',
    Text: 'text'
} as const;
export type HomeownershipConsentChannel = typeof HomeownershipConsentChannel[keyof typeof HomeownershipConsentChannel];


export function HomeownershipConsentChannelFromJSON(json: any): HomeownershipConsentChannel {
    return HomeownershipConsentChannelFromJSONTyped(json, false);
}

export function HomeownershipConsentChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipConsentChannel {
    return json as HomeownershipConsentChannel;
}

export function HomeownershipConsentChannelToJSON(value?: HomeownershipConsentChannel | null): any {
    return value as any;
}

